import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import FormControl from "@material-ui/core/FormControl";
import GlobalApi from "./../../Global";
import Colors from "./../../Global/colors";
import DarkButton from "../../Global/DarkButton";
import Button from "@material-ui/core/Button";
import Spinner from "../../Global/Spinner";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import refresh_token from "./../../Global/refresh_token";
import dotsH from "../../Assets/dotsH.png";
import swal from "@sweetalert/with-react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";
import "./template.css";

//Redux
import { useSelector, useDispatch } from "react-redux";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor: "#1a73e8",
    // display:'none'
  },
})(Tabs);

export default function MoreOptionDailog({
  template_id,
  created_by,
  getTemplates,
  getPackageDetails,
  permissions_obj,
  setAnchorEl,
}) {
  const { t } = useTranslation();
  //   const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("sm");
  const [value, setValue] = useState(1);
  const [currentCompany, setCurrentCompany] = useState("");

  let company = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      setCurrentCompany(company);
    },
    [company?.id]
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setAnchorEl(null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    getTemplates(company, true);
    getPackageDetails();
  };

  return (
    <React.Fragment>
      {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open max-width dialog
      </Button> */}
      <MenuItem
        onClick={handleClickOpen}
        style={{ minHeight: window.innerWidth <= 500 && "25px" }}
      >
        <img src={dotsH} width={20} alt="..." />
        &nbsp; {t("More Options")}
      </MenuItem>

      {/* <div className="text-center" onClick={handleClickOpen}>
        <p className="templateIndustry" style={{ fontSize: "14px", cursor: "pointer" }}>
          {"More Options"}
        </p>
      </div> */}
      <Dialog
        className="moreDialogue"
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        scroll={"paper"}
      >
        <DialogTitle id="max-width-dialog-title" onClose={handleClose}>
          <p
            className="label2"
            style={{
              marginBottom: 5,
              fontSize: 16,
              marginTop: 7,
              color: Colors.globalColor8,
              textTransform: "uppercase",
            }}
          >
            {t("Template Details")}
          </p>
        </DialogTitle>
        <DialogContent>
          <Paper square variant={"outlined"}>
            <AntTabs
              value={value}
              onChange={handleChange}
              className="MoreOptionsTab"
            >
              <Tab
                style={{
                  marginTop: "5px",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  textTransform: "uppercase",
                  fontSize: 12,
                  fontWeight: "bold",
                  backgroundColor:
                    value == 0 ? Colors.globalColor9 : "transparent",
                  color: value == 0 ? "#1a73e8" : "black",
                }}
                label={t("Details")}
              />
              <Tab
                style={{
                  marginTop: "5px",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  textTransform: "uppercase",
                  fontSize: 12,
                  fontWeight: "bold",
                  backgroundColor:
                    value == 1 ? Colors.globalColor9 : "transparent",
                  color: value == 1 ? "#1a73e8" : "black",
                }}
                label={t("Share")}
              />
              <Tab
                style={{
                  marginTop: "5px",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  textTransform: "uppercase",
                  fontSize: 12,
                  fontWeight: "bold",
                  backgroundColor:
                    value == 2 ? Colors.globalColor9 : "transparent",
                  color: value == 2 ? "#1a73e8" : "black",
                }}
                label={t("Schedule")}
              />
            </AntTabs>
          </Paper>

          <Paper
            square
            variant={"outlined"}
            style={{ backgroundColor: "white" }}
          >
            <TabPanel value={value} index={0}>
              <DetailsContainer
                created_by={created_by}
                template_id={template_id}
                handleClose={handleClose}
                permissions_obj={permissions_obj}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ShareContainer
                created_by={created_by}
                template_id={template_id}
                permissions_obj={permissions_obj}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <ScheduleContainer
                created_by={created_by}
                template_id={template_id}
                permissions_obj={permissions_obj}
              />
            </TabPanel>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            className="addBtn"
            component="span"
            style={{ backgroundColor: Colors.globalColor8 }}
            onClick={handleClose}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const DetailsContainer = ({
  template_id,
  created_by,
  handleClose,
  permissions_obj,
}) => {
  const { t } = useTranslation();
  const [template, setTemplate] = useState(null);
  const [currentUser, setCurrentUser] = useState({});
  const [shares, setShares] = useState(null);

  useEffect(() => {
    fetchtemplate();
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    fetchShares();

    setCurrentUser(data);
  }, []);

  const fetchtemplate = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      template_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_template_with_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          setTemplate(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchtemplate();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const fetchShares = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      template_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/TemplateShare/get_all_template_shares?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          setShares(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchShares();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  function handleDelete() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    swal({
      title: t("Are you sure?"),
      text: t("You will not be able to recover this imaginary file!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          let req = await fetch(
            GlobalApi + "/Template/delete_template/" + template_id,
            {
              method: "GET",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
            }
          );

          let reqJson = await req.json();

          if (reqJson.status == "Success") {
            handleClose();
            swal({
              title: t("Success"),
              text: t("Template successfully deleted"),
              icon: "success",
            });
          } else {
            swal({
              title: t("Can not Delete Template"),
              text: reqJson.err,
              icon: "error",
            });
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
  }

  let disabled =
    created_by == currentUser?.user_id
      ? false
      : true ||
        shares?.filter((v) => v.user_id === currentUser.user_id)[0]?.isOwner ==
          false
      ? true
      : false;

  if (template === null) {
    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <CircularProgress style={{ color: Colors.globalColor8 }} />
      </div>
    );
  } else {
    return (
      <>
        <Paper
          variant="outlined"
          style={{ padding: 5, backgroundColor: "white" }}
          className="mainDetailsContainer"
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Typography variant="p">{t("Title")}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="p" style={{ fontWeight: "bolder" }}>
                {template.title}
              </Typography>
            </Grid>
          </Grid>
          <hr />
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Typography variant="p">{t("Description")}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="p" style={{ fontWeight: "bolder" }}>
                {template.description}
              </Typography>
            </Grid>
          </Grid>
          <hr />
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Typography variant="p">{t("Owner")}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="p" style={{ fontWeight: "bolder" }}>
                {template.User?.first_name} {template.User?.last_name}
              </Typography>
            </Grid>
          </Grid>
          <hr />
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Typography variant="p">{t("Created At")}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="p" style={{ fontWeight: "bolder" }}>
                {moment(new Date(template.createdAt)).format(
                  "MMMM DD, YYYY hh:mm:a"
                )}
              </Typography>
            </Grid>
          </Grid>

          <hr />
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Typography variant="p">{t("Last Updated At")}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="p" style={{ fontWeight: "bolder" }}>
                {moment(new Date(template.updatedAt)).format(
                  "MMMM DD, YYYY hh:mm:a"
                )}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        <hr />
        <Paper
          variant="outlined"
          style={{ padding: 5, backgroundColor: "white" }}
        >
          {currentUser?.super_admin == true ||
          permissions_obj["Admin"] == true ||
          permissions_obj["Template Creation"] == true ? (
            <Button
              variant="contained"
              type="submit"
              onClick={handleDelete}
              className="addBtnRed"
              component="span"
              fullWidth
              size="large"
              style={{
                cursor: "pointer",
                backgroundColor: "red",
                opacity: disabled ? 0.5 : 1,
              }}
              disabled={disabled}
            >
              {t("Delete this Template")}
            </Button>
          ) : (
            <Button
              variant="contained"
              type="submit"
              className="addBtnGrey"
              component="span"
              fullWidth
              size="large"
              style={{ backgroundColor: "#dadada", opacity: 1 }}
              disabled={true}
            >
              {t("Delete this Template")}
            </Button>
          )}
        </Paper>
      </>
    );
  }
};

const ScheduleContainer = ({ template_id, created_by }) => {
  const {t} = useTranslation(); 
  const [schedules, setSchedules] = useState([]);
  const history = useHistory();
  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      template_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_schedule_template?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          setSchedules(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchSchedules();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <div>
      {schedules.map((v) => {
        return (
          <Paper square variant={"outlined"} style={{ padding: 10, margin: 5 }}>
            {v.title}
          </Paper>
        );
      })}

      {/* <DarkButton
      style={{backgroundColor:Colors.globalColor8}}
        fullWidth
        onClick={() =>
          history.push({
            pathname: "/schedule-create",
            state: { template_id: template_id },
          })
        }
      >
        Schedule Inspection
      </DarkButton> */}

      <Button
        variant="contained"
        type="submit"
        className="addBtn"
        component="span"
        style={{ backgroundColor: Colors.globalColor8 }}
        fullWidth
        onClick={() =>
          history.push({
            pathname: "/schedule-create",
            state: { template_id: template_id },
          })
        }
      >
        {t("Schedule Inspection")}
      </Button>
    </div>
  );
};

const ShareContainer = ({ template_id, created_by }) => {
  const { t } = useTranslation();
  const [users, setUsers] = React.useState([]);
  const [shares, setShares] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [currentUser, setCurrentUser] = useState({});
  const [currentCompanyShare, setCurrentCompanyShare] = useState("");

  let companyData = useSelector((state) => state.companyReducer.company);

  useEffect(
    () => {
      setCurrentCompanyShare(companyData);
      fetchUsers(companyData);
      fetchShares();
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);

      setCurrentUser(data);
      console.log(template_id);
    },
    [companyData]
  );

  const fetchUsers = (company) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response of fetch users", response);
        if (response.status == "Success") {
          setUsers(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUsers(company);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const fetchShares = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      template_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/TemplateShare/get_all_template_shares?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status == "Success") {
          setShares(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchShares();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  async function handleSubmit() {
    console.log("shared careted", template_id);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    if (selectedUsers) {
      if (shares.filter((v) => v.user_id == selectedUsers).length == 0) {
        await fetch(GlobalApi + "/TemplateShare/create_template_share", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            user_id: selectedUsers,
            company_id: currentCompanyShare.id,
            template_id,
            isOwner: false,
            isEditor: false,
          }),
        });

        fetchShares();
      } else {
        swal(t("Warning"), t("User already exists"), "warning");
      }
    } else {
      swal(t("Warning"), t("No User Selected"), "warning");
    }
  }

  async function handleEditorToggle(isEditor, template_share_id) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/TemplateShare/edit_template_share", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        template_share_id,
        isEditor,
      }),
    });

    fetchShares();
  }

  async function handleDelete(template_share_id) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/TemplateShare/delete_template_share", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        template_share_id,
      }),
    });

    fetchShares();
  }
  // console.log(currentUser.user_id,
  //   currentUser.user_id !== currentUser.user_id || shares.filter((v) => v.user_id === currentUser.user_id)[0]
  //   ?.isOwner == false ? true : false
  // );

  console.log("USERS>>>>>>>>", users);

  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={9}>
            {/* <Autocomplete
              id="combo-box-demo"
              options={users}
              getOptionLabel={(option) =>
                `${option.first_name} ${option.last_name}`
              }
              fullWidth
              value={selectedUsers}
              onChange={(event, newValue) => {
                setSelectedUsers(newValue);
              }}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Select User"
                  variant="outlined"
                />
              )}
            /> */}

            <FormControl
              variant="outlined"
              size="small"
              style={{ width: "100%", height: "40px" }}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {t("Select User")}
              </InputLabel>
              <Select
                size="small"
                style={{ backgroundColor: "#f7f9fb" }}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selectedUsers}
                onChange={(e) => {
                  setSelectedUsers(e.target.value);
                }}
                label={t("Select User")}
              >
                {users.map((item, index) => {
                  return (
                    <MenuItem value={item.id}>
                      {item.first_name + " " + item.last_name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3} align="right">
            {/* <DarkButton onClick={handleSubmit} style={{ backgroundColor: Colors.globalColor8 }} // size="large"
              disabled={created_by == currentUser.user_id ? false : true || shares.filter((v) => v.user_id === currentUser.user_id)[0]?.isOwner == false ? true : false}>
              Add Share
            </DarkButton> */}

            <Button
              variant="contained"
              type="submit"
              className="addBtn"
              component="span"
              onClick={handleSubmit}
              style={{ backgroundColor: Colors.globalColor8 }} // size="large"
              disabled={
                created_by == currentUser.user_id
                  ? false
                  : true ||
                    shares.filter((v) => v.user_id === currentUser.user_id)[0]
                      ?.isOwner == false
                  ? true
                  : false
              }
            >
              {t("Add Share")}
            </Button>
          </Grid>

          <Grid item xs={12}>
            <hr />
            {shares === null && (
              <div style={{ width: "100%", textAlign: "center" }}>
                <CircularProgress style={{ color: Colors.globalColor8 }} />
              </div>
            )}
            {shares != null &&
              shares
                .sort(
                  (a, b) =>
                    new Date(a.createdAt).getTime() -
                    new Date(b.createdAt).getTime()
                )
                .map((share) => {
                  return (
                    <Paper
                      variant={"outlined"}
                      style={{
                        marginTop: 10,
                        padding: 10,
                        backgroundColor: "#eaf7fe",
                      }}
                    >
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item xs={6}>
                          <Typography
                            variant="p"
                            style={{ fontWeight: "bolder", display: "block" }}
                          >
                            {share?.User?.first_name} {share?.User?.last_name}
                          </Typography>
                          <Typography variant="p" style={{ fontsize: 10 }}>
                            {share?.isOwner == true ||
                            share?.user_id === created_by ? (
                              <>{t("Owner")}</>
                            ) : (
                              <>{t("Viewer")}</>
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ color: Colors.globalColor8 }}
                                checked={share?.isEditor}
                                onChange={() =>
                                  handleEditorToggle(!share?.isEditor, share.id)
                                }
                                disabled={
                                  created_by == currentUser.user_id
                                    ? false
                                    : true ||
                                      shares.filter(
                                        (v) => v.user_id === currentUser.user_id
                                      )[0]?.isOwner == false
                                    ? true
                                    : false
                                }
                              />
                            }
                            label={t("Is Editor")}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <IconButton
                            aria-label="delete"
                            onClick={() => handleDelete(share.id)}
                            disabled={
                              created_by == currentUser.user_id
                                ? false
                                : true ||
                                  shares.filter(
                                    (v) => v.user_id === currentUser.user_id
                                  )[0]?.isOwner == false
                                ? true
                                : false
                            }
                          >
                            <DeleteIcon
                              fontSize="small"
                              style={{ color: Colors.globalColor8 }}
                            />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  );
                })}
          </Grid>
        </Grid>
      </div>
    </>
  );
};
